import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/img/paas.png'


const _hoisted_1 = { class: "helpOut" }
const _hoisted_2 = { class: "mobile-head" }
const _hoisted_3 = { class: "mobile-main" }
const _hoisted_4 = { class: "main-head" }
const _hoisted_5 = { class: "searchB" }
const _hoisted_6 = {
  key: 0,
  class: "searchResult"
}
const _hoisted_7 = {
  key: 1,
  class: "searchResult1"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "searchItemName" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "title-box" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "title-icon"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = ["onLoadeddata"]
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "head-icon"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "head-mes" }
const _hoisted_23 = {
  key: 0,
  class: "type-mes"
}
const _hoisted_24 = { class: "type-title" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "title-mes" }
const _hoisted_27 = { class: "aws-paas6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_btn = _resolveComponent("search-btn")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Footer1 = _resolveComponent("Footer1")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClickLogo('http://www.awspaas.com/'))),
        style: {"cursor":"pointer","height":"18px"},
        src: _imports_0,
        alt: "logo"
      }),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClickLogo('https://www.actionsoft.com.cn/'))),
        class: "head-btn"
      }, "访问官网")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mobile-title" }, [
          _createElementVNode("span", { class: "title" }, "欢迎访问AWS PaaS"),
          _createElementVNode("span", { class: "title" }, "帮助中心")
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_popover, {
            placement: "bottom",
            trigger: "manual",
            "popper-class": "searchInputPopover",
            visible: _ctx.showPopover,
            "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showPopover) = $event)),
            teleported: false,
            disabled: _ctx.searchValue=='',
            style: {"width":"auto !important"}
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_search_btn, {
                onChangeSearchValue: _ctx.changeSearchValue,
                onSearchClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPopover=true))
              }, null, 8, ["onChangeSearchValue"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "searchBox",
                style: _normalizeStyle({'max-height':_ctx.searchBoxMax+'px'})
              }, [
                (_ctx.searchList.length!=0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.searchTotal) + "个与“" + _toDisplayString(_ctx.searchValue) + "”相关的结果", 1))
                  : _createCommentVNode("", true),
                (_ctx.searchList.length==0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, "未检测到搜索结果"))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    onClick: _withModifiers(($event: any) => (_ctx.handleSelectId(item.current)), ["stop"]),
                    key: item.id,
                    class: "searchItem"
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "circle" }, null, -1)),
                      _createElementVNode("div", {
                        class: "mes",
                        innerHTML: item.current.name
                      }, null, 8, _hoisted_10)
                    ]),
                    _createElementVNode("div", {
                      class: "searchItemMes",
                      innerHTML: item.content
                    }, null, 8, _hoisted_11)
                  ], 8, _hoisted_8))
                }), 128))
              ], 4)
            ]),
            _: 1
          }, 8, ["visible", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titleList, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["title-card", item.jumpUrl?'click-card':'']),
            key: item.id
          }, [
            _createElementVNode("div", {
              class: "title-mes",
              onClick: ($event: any) => (_ctx.openMore(item))
            }, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "title-mes-icon" }, null, -1)),
              _createTextVNode(_toDisplayString(item.groupName) + " ", 1),
              (item.jumpUrl)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_el_icon, { style: {"margin-left":"4px","line-height":"17px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowRight)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_13)
          ], 2))
        }), 128))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoList, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "video-card",
          key: item.id
        }, [
          (item.imageUrl&&!item.videoLoaded)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "video-image",
                src: item.imageUrl,
                alt: ""
              }, null, 8, _hoisted_15))
            : _createCommentVNode("", true),
          _createElementVNode("video", {
            class: "video-play",
            controls: false,
            autoplay: "autoplay",
            muted: "muted",
            loop: "loop",
            onLoadeddata: ($event: any) => (_ctx.onVideoLoaded(item))
          }, [
            _createElementVNode("source", {
              src: item.videoUrl,
              type: "video/mp4"
            }, null, 8, _hoisted_17),
            _createElementVNode("source", {
              src: item.videoUrl,
              type: "video/ogg"
            }, null, 8, _hoisted_18)
          ], 40, _hoisted_16)
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeList, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "type-card",
          key: item.id
        }, [
          _createElementVNode("div", {
            class: "type-head",
            onClick: ($event: any) => (_ctx.openMore(item))
          }, [
            (item.imageUrl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("img", {
                    style: {"width":"100%","height":"100%"},
                    src: item.imageUrl,
                    alt: ""
                  }, null, 8, _hoisted_21)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_22, [
              _createTextVNode(_toDisplayString(item.groupName), 1),
              (item.jumpUrl)
                ? (_openBlock(), _createBlock(_component_el_icon, {
                    key: 0,
                    style: {"margin-left":"5px","line-height":"17px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowRight)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_19),
          (item.groupDesc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(item.groupDesc), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (one) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => (_ctx.openMore(one)),
                key: one.id,
                class: "title-item",
                style: _normalizeStyle({width:one.itemName.length>4?'100%':'50%'})
              }, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "title-circle" }, null, -1)),
                _createElementVNode("div", _hoisted_26, _toDisplayString(one.itemName), 1)
              ], 12, _hoisted_25))
            }), 128))
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_Footer1),
    _createElementVNode("div", _hoisted_27, [
      (!_ctx.showAws6)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "docOpen",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAws6=true))
          }, [...(_cache[11] || (_cache[11] = [
            _createElementVNode("i", { class: "iconfont switchIcon6" }, "", -1)
          ]))]))
        : _createCommentVNode("", true),
      (_ctx.showAws6)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "docOpen",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAws6=false)),
            style: {"justify-content":"flex-end"}
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("i", {
              class: "iconfont switchIcon6",
              style: {"margin-right":"4px"}
            }, "", -1)
          ]))]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["sixBox", _ctx.showAws6?'openAws6':_ctx.showAws6===false?'closeAws6':'']),
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toPaasSix && _ctx.toPaasSix(...args)))
      }, [...(_cache[13] || (_cache[13] = [
        _createElementVNode("span", { style: {"padding":"0 2px"} }, "访问6平台文档", -1)
      ]))], 2)
    ])
  ]))
}